/* eslint-disable no-param-reassign, max-len */
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
  data() {
    return {
      isNewField: false,
      idPropertiesField: 'propertiesField',
      idModalFieldLibrary: 'modalFieldLibrary',
      showModalExternalUrl: false,
      selectedField: null,
      selectedIndexField: null,
      onValueChange: '',
      showModalCompanyDrive: false,
    };
  },

  watch: {
    showModalExternalApi(val) {
      if (val) {
        this.$refs.modalExternalApi.show();
        this.showModalExternalUrl = true;
      } else {
        this.$refs.modalExternalApi.hide();
        this.showModalExternalUrl = false;
      }
    },
  },

  computed: {
    ...mapState('jStoreExperienceManagerV2', ['propertiesOpened', 'showModalFieldLibrary', 'isShowModalFieldFromGroup', 'showModalExternalApi']),

    variableOptionsWatermark() {
      const listData = [];
      if (this.formDetail.form_data_id) {
        const listColumnsVal = Object.values(this.form_data_detail[0].columns);
        if (listColumnsVal.length > 0) {
          listColumnsVal.forEach((column) => {
            const findInColumn = this.dataSetup.column.find(f => f.field_data_key === column.name);
            if (findInColumn && (column.type === 'text' || column.type === 'maps' || column.type === 'timestamp')) {
              listData.push({
                id: column.name,
                label: column.name,
                text: column.name,
              });
            }
          });
        }
      }
      return listData;
    },
  },

  methods: {
    ...mapActions('jStoreFormUi', [
      'actionGetDetailForm', 'actionGetDetailMultiForm', 'actionSetForm',
      'actionSetMultiForm', 'actionGetDetailFormData',
    ]),
    ...mapMutations('jStoreExperienceManagerV2', [
      'setPropertiesOpened', 'setValueOnChangeScript', 'setIsBulk', 'setIsSearch', 'setIsDataSet',
      'setIsFieldGroup', 'setIsTableGroup', 'setIsDataPreview', 'setIsDataPreviewGroup', 'setValueCompanyDrivePath',
    ]),

    modifyData({ added }) {
      if (added) {
        // Set to selected & open properties
        this.selectedField = this.dataSetup.column[added.newIndex];
        this.selectedIndexField = added.newIndex;
        this.isNewField = true;

        this.toggleProperties(true);
      }
    },

    openPropertiesField(column, index) {
      if (this.selectedField) {
        if (index !== this.selectedIndexField) {
          if (!this.selectedField.field_ui_key) {
            this.dataSetup.column.splice(this.selectedIndexField, 1);
          }
          this.toggleProperties(false);

          setTimeout(() => {
            this.selectedField = column;
            this.selectedIndexField = index;
            this.toggleProperties(true);
          }, 250);
        }
      } else {
        this.selectedField = column;
        this.selectedIndexField = index;

        this.toggleProperties(true);
      }
    },

    deleteField(index) {
      this.$swal({
        title: 'Delete',
        text: 'Are you sure to delete field ?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D0021B',
        cancelButtonColor: '#606060',
        titleColor: '#676767',
      }).then(async (result) => {
        if (result.value) {
          this.dataSetup.column.splice(index || this.selectedIndexField, 1);
          this.setChangesValueView(true);
          this.toggleProperties(false);
        }
      });
    },

    toggleProperties(status) {
      if (status) {
        this.setPropertiesOpened(true);
        setTimeout(() => {
          const element = document.getElementById(this.idPropertiesField);
          if (element) element.classList.add('show-properties-field');
        }, 200);
      } else {
        const element = document.getElementById(this.idPropertiesField);
        if (element) element.classList.remove('show-properties-field');
        this.setPropertiesOpened(false);

        setTimeout(() => {
          this.selectedField = null;
          this.selectedIndexField = null;
          this.isNewField = false;
          this.setIsBulk(false);
          this.setIsSearch(false);
          this.setIsDataSet(false);
          this.setIsFieldGroup(false);
          this.setIsTableGroup(false);
          this.setIsDataPreview(false);
          this.setIsDataPreviewGroup(false);
        }, 200);
      }
    },

    openModalFieldLibrary() {
      if (!this.propertiesOpened) {
        this.setShowModalFieldLibrary(true);
        this.setIsShowModalFieldFromGroup(false);

        setTimeout(() => {
          const element = document.getElementById(this.idModalFieldLibrary);
          if (element) element.classList.add('show');
        }, 100);
      }
    },

    closeModalFieldLibrary(data) {
      const element = document.getElementById(this.idModalFieldLibrary);
      if (element) element.classList.remove('show');

      if (this.isShowModalFieldFromGroup) {
        if (data) this.setSourceModalFieldLibrary(data);
      } else if (!this.isShowModalFieldFromGroup) {
        if (data) {
          const index = this.dataSetup.column.push(data) - 1;
          this.selectedField = this.dataSetup.column[index];
          this.selectedIndexField = index;
          this.isNewField = true;

          setTimeout(() => {
            this.toggleProperties(true);
          }, 200);
        }
      }

      setTimeout(() => {
        this.setShowModalFieldLibrary(false);
        this.setIsShowModalFieldFromGroup(false);
      }, 300);
    },

    submitPreview(params) {
      delete params.field_ui_key;
      const data = JSON.parse(JSON.stringify(this.dataSetup.column[this.selectedIndexField]));
      data.grid_size = params.grid_size;
      data.name = params.name;
      data.placeholder = params.placeholder;
      this.dataSetup.column[this.selectedIndexField] = data;
      this.$forceUpdate();
    },

    submitField(mode, params, isCancel) {
      if (params.field_ui_key) {
        const findKeySame = this.dataSetup.column.find(e => e.field_ui_key === params.field_ui_key);
        if (mode === 'add') {
          if (!findKeySame) {
            this.isError = false;
            if (!isCancel) {
              this.setChangesValueView(true);
            }
            this.dataSetup.column.push(params);
            this.toggleProperties(false);
          } else {
            this.isError = true;
            this.toggleProblem('Key cannot be the same!');
          }
        } else {
          // eslint-disable-next-line
          if (this.selectedField.field_ui_key === params.field_ui_key) {
            this.isError = false;
            if (!isCancel) {
              this.setChangesValueView(true);
            }
            this.dataSetup.column[this.selectedIndexField] = params;
            this.toggleProperties(false);
          } else {
            // eslint-disable-next-line
            if (!findKeySame) {
              this.isError = false;
              if (!isCancel) {
                this.setChangesValueView(true);
              }
              this.dataSetup.column[this.selectedIndexField] = params;
              this.toggleProperties(false);
            } else {
              this.isError = true;
              this.toggleProblem('Key cannot be the same!');
            }
          }
        }
      } else {
        this.dataSetup.column.splice(this.selectedIndexField, 1);
      }
    },

    async submitForm() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        this.$swal({
          title: 'Update',
          text: `Are you sure to update ${this.formDetail.name}?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Update',
          confirmButtonColor: '#42a5ce',
          cancelButtonColor: '#D2232A',
          titleColor: '#D2232A',
        }).then(async (result) => {
          if (result.value) {
            let res;
            if (!this.isMultipleForm) {
              res = await this.actionSetForm(this.genData);
            } else {
              res = await this.actionSetMultiForm(this.genData);
            }
            if (!res.error) {
              this.setChangesValueView(false);
              const dataFilter = {
                id: [this.$route.params.id],
              };
              const param = {
                limit: 0,
                page: 1,
                filter: JSON.stringify(dataFilter),
              };
              if (!this.isMultipleForm) {
                await this.actionGetDetailForm(param);
              } else {
                await this.actionGetDetailMultiForm(param);
              }
            }
          }
        });
      }
      if (this.$v.dataSetup.$error) {
        this.toggleProblem('Please completed the required Configuration');
      }
    },

    async deleteView(type) {
      this.$swal({
        title: 'Delete',
        text: 'Are you sure to delete this view?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        titleColor: '#D2232A',
      }).then(async (result) => {
        if (result.value) {
          const params = this._.cloneDeep(this.formDetail);
          if (type === 'create') {
            params.create_view = null;
            this.dataSetup = {
              title: null,
              column: [],
              action_buttons: [],
            };
          } else if (type === 'detail') {
            params.detail_view = null;
            this.dataSetup = {
              title: null,
              column: [],
              is_pagescreen: true,
              action_buttons: [],
            };
          }

          let res;
          if (!this.isMultipleForm) {
            res = await this.actionSetForm(params);
          } else {
            res = await this.actionSetMultiForm(params);
          }
          if (!res.error) {
            this.setChangesValueView(false);
            const dataFilter = {
              id: [this.$route.params.id],
            };
            const param = {
              limit: 0,
              page: 1,
              filter: JSON.stringify(dataFilter),
            };
            if (!this.isMultipleForm) {
              await this.actionGetDetailForm(param);
            } else {
              await this.actionGetDetailMultiForm(param);
            }
            this.toggleConfiguration(false);
          }
        }
      });
    },

    openModalFullScript(val) {
      this.$refs.modalFullScript.show();
      this.onValueChange = val;
      setTimeout(() => {
        this.openEditor = true;
      }, 200);
    },

    minimizeBlock() {
      const value = this.$refs.scriptEditor !== undefined ? this.$refs.scriptEditor.getData() : '';
      this.setValueOnChangeScript(value);
      this.$refs.modalFullScript.hide();
      this.openEditor = false;
    },

    openModalCompanyDrive() {
      this.showModalCompanyDrive = true;
      setTimeout(() => {
        const element = document.getElementById('idModalCompanyDrive');
        if (element) element.classList.add('show');
      }, 200);
    },

    handleCloseModalCompanyDrive(data) {
      this.setValueCompanyDrivePath(data);
      const element = document.getElementById('idModalCompanyDrive');
      if (element) element.classList.remove('show');
      setTimeout(() => {
        this.showModalCompanyDrive = false;
        this.setValueCompanyDrivePath(null);
      }, 200);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/form-ui-v2/jMixSetupCreateDetail.js